import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
// import 'react-data-table-component-extensions/dist/utilities';
// import {CSVLink} from 'react-csv';
import { ExportToExcelLive } from '../Excelfile';
import Navbar from '../Navbar';
import { toast } from 'react-toastify';
import { UserDetailData } from '../HOC/UserDetailData';
import { hqlistdata } from '../HOC/HqDetailData';
import Spinner from 'react-bootstrap/Spinner';
import Loaders from './Spinners/Loaders';


const Sapsoreport = () => {
    
    const navigate = useNavigate();

    
    // const [userData, setUserData] = useState({});    
    const{userData} = UserDetailData();
    const [filtereddata, setFiltereddata] = useState([]);
    const [filtereddncndata, setFiltereddncndata] = useState([]);
    const [values, setValues] = useState([]);
    const [filtervalues, setFiltervalues] = useState([]);
    const [tcsdbdata, SetTcsdbdata] = useState({});
    const [tcsdbdncndata, SetTcsdbdncndata] = useState({});
    const [usermapData, setUsermapData] = useState({});
    const [userdivmapData, setUserdivmapData] = useState({});
    const [selectinvsitedata, setSelectinvsitedata] = useState();
    const [hqhirData, setHqhirData] = useState({});
    const [btnsitestate, setBtnsitestate] = useState('');
    const [btnrefstate, setBtnrefstate] = useState('none');
    const [btnstate, setBtnstate] = useState('none');
    const [hqbtnstate, setHqbtnstate] = useState('none');
    const [btnreport, setBtnreport] = useState('none');
    const [btndncnreport, setBtndncnreport] = useState('none');
    const [btnfinalreport, setBtnfinalreport] = useState('none');
    const [btnfinaldncnreport, setBtnfinaldncnreport] = useState('none');
    const senempmapdata = userData.empCode;
    const sendivempmapdata = userData.empCode;
    const [datefromValue, setDatefromValue] = useState(null);
    const [datetoValue, setDatetoValue] = useState(null);
    const [hqNamedata, setHqNamedata] = useState('');
    const [hqfvalue, setHqfvalue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
       
    
    function formatDate(date) {
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) 
    month = '0' + month;
  if (day.length < 2) 
    day = '0' + day;

  return [year, month, day].join('');
}
    
    
    
    const tcsfromDate = datefromValue;
    const tcstoDate = datetoValue;
    const sapfromDate = formatDate(datefromValue);
    const saptoDate = formatDate(datetoValue);

    
    

    // function allhqasmdata(){

    //   let hqcodefinalfilter = values.map((codedata)=> codedata.hqCode);
    //   setFiltervalues(hqcodefinalfilter);
    // }
    
    let finalsitemapdata = '';
    
    for(let i=0; i < usermapData.length; i++)
    {
        finalsitemapdata = finalsitemapdata + usermapData[i].siteCode + ",";
    }

    let finalplantmapdata = '';
    
    for(let i=0; i < usermapData.length; i++)
    {
        finalplantmapdata = finalplantmapdata + usermapData[i].plant + ",";
    }

    let finaldivmapdata = '';
    
    for(let i=0; i < userdivmapData.length; i++)
    {
        finaldivmapdata = finaldivmapdata + userdivmapData[i].divisionCode + ",";
    }

     let finlsapdivmapdata = [];  
    for(let i=0; i < userdivmapData.length; i++)
    {
        finlsapdivmapdata[i] = userdivmapData[i].divisionone;
    }
    const uniquefinlsapdivmapdata = [...new Set(finlsapdivmapdata)];

    

    const empdivemapdata = async () => {
        
        try {
            if(!sendivempmapdata || !datefromValue || !datetoValue)
            {
                toast.error("Please Select the Date Filter or Connect to QRS-Administration.", { position: "top-center" });
            }
            else if(datefromValue > datetoValue)
            {
              toast.error("Please select the Correct Date Range.", { position: "top-center" });
            }
            else if((Date.parse(datetoValue)-Date.parse(datefromValue))/86400000 > 32)
            {
              toast.error("Please select the below 1 Months data.", { position: "top-center" });
            }
            else
            {
              
            const res = await fetch('/tcsdb/divemapdata/'+sendivempmapdata, {
                method: "GET",
                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                    },
                    credentials: "include"  
            });
            const empmapdata = await res.json();
            if(res.status === 404)
            {
                toast.error("You have Zero Data Available.", { position: "top-center" });
            }
            else
            {
            setUserdivmapData(empmapdata);
            setBtnsitestate('none');            
            setBtnrefstate('');
            // console.log(empmapdata);
            // console.log(finalsitemapdata);
            }
        }
        } catch (err) {
            console.log(err);
            
        }

    }

    const empsitemapdata = async () => {
        
        try {
            if(!senempmapdata)
            {
                toast.error("Please Connect to QRS-Administration.", { position: "top-center" });
            }
            else
            {
            const res = await fetch('/tcsdb/sitemapdata/'+senempmapdata, {
                method: "GET",
                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                    },
                    credentials: "include"  
            });
            const empmapdata = await res.json();
            if(res.status === 404)
            {
                toast.error("You have Zero Data Available.", { position: "top-center" });
            }
            else
            {
            setUsermapData(empmapdata);            
            setBtnrefstate('none');
            setBtnreport('');            
            setBtndncnreport('');            
            }
        }
        } catch (err) {
            console.log(err);            
        }
    }


   
    
    let tempsval =0;
    for(let i=0; i<tcsdbdata.length; i++)
    {
      if(tcsdbdata[i].HQ_CODE === hqfvalue)
      {
        tempsval += tcsdbdata[i].TAXABLE_AMOUNT;
      }
    }
    let hqdatasval=Math.round(tempsval*100)/100;

    const hqcodelist = async (hqdata) => {
      
        const response = await hqlistdata(hqdata);        
        setValues(response);
        let hqcodefinalfilter = response.map((codedata)=>{return codedata.hqCode});
        setFiltervalues(hqcodefinalfilter);       
      }


      const handlehqwisedata = () => {
        
        setHqbtnstate('none');
        // console.log(filtervalues);
        if(tcsdbdata.length <=0)
        {
          toast.error("There are no record to display.", { position: "top-center" });
        }
        else{
        // let myArray = [];
        for(let i =0; i<values.length; i++ )
        {
          let temp = values[i].hqCode;
          // let tempname = values[i].hqName;
          // console.log(values);
          let sval = 0;
          let svaldncn= 0;
          for(let j=0; j<tcsdbdata.length; j++)
          {
            if(tcsdbdata[j].HQ_CODE === temp)
            sval += tcsdbdata[j].TAXABLE_AMOUNT;
          }

          for(let j=0; j<filtereddncndata.length; j++)
          {            
            if(filtereddncndata[j].HQ_CODE === temp)  // For SAP
            svaldncn += filtereddncndata[j].TAXABLE_AMOUNT; // for SAP
          }
          // myArray[i]=("HQ Code:-" + temp + "HQ Name:" +tempname + "Sale Value:" + Math.round(sval,2));
          // ("HQ Code:-" + temp + "HQ Name:" +tempname + "Sale Value:" + Math.round(sval,2));
          // console.log("HQ Code:-" + temp + "HQ Name:" +tempname + "Sale Value:" + Math.round(sval,2));
          values[i].SalesValue = sval;
          values[i].DebitCreditNote = svaldncn; 
          values[i].DiffValue = values[i].SalesValue + values[i].DebitCreditNote - values[i].CurrentIQMValue;         
        }

        // let finalsval = 0;
        // let finalsvaldncn = 0;
        // let finalCurrentIQMValue = 0;
        // let finalDiffValue = 0;
        // let lastrownumber = (values.length)+1;
        // for(let i =0; i<values.length; i++ )
        // {
        //   finalsval += values[i].SalesValue;
        //   finalsvaldncn += values[i].DebitCreditNote;          
        //   finalCurrentIQMValue += values[i].CurrentIQMValue;
        //   finalDiffValue += values[i].DiffValue;
        //   lastrownumber.DebitCreditNote = finalsvaldncn;
          
        // }

        setHqbtnstate('');
      }
      }

      

      const handlefromDateUpdate = async(e) => {        
        const datefValue = e.target.value;                
        setDatefromValue(datefValue);                 
      }

      const handletoDateUpdate = async(e) => {        
        const datetValue = e.target.value;                
        setDatetoValue(datetValue);               
      }
    

    const divwisereport = async () => {        
        try {
            // allhqasmdata();
            let frontsitedata = finalsitemapdata;
            let frontitemDivision = finaldivmapdata;            
            if(!senempmapdata || !frontsitedata || !frontitemDivision || !tcsfromDate || !tcstoDate || !hqfvalue || hqfvalue === "--Select--")
            {
                toast.error("Please select above field .", { position: "top-center" });
            }
            else if(tcsfromDate > tcstoDate)
            {
              toast.error("Please select the Correct Date Range.", { position: "top-center" });
            }
            else if((Date.parse(datetoValue)-Date.parse(datefromValue))/86400000 > 32)
            {
              toast.error("Please select the below 3 Months data.", { position: "top-center" });
            }
            else
            {
            setBtnreport('true');
            setBtnstate('none');
            setIsLoading(true);            
            const data = { frontsitedatas:"", frontitemDivisions:"", tcsfromDates:"", tcstoDates:"", partyCodes:"" };

            const res = await fetch('/tcsdb/sapdivwisereports',{
              method: "POST",
              headers:{
                  // "Accept": "application/json",
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({
                frontsitedatas:finalplantmapdata, frontitemDivisions: finaldivmapdata, tcsfromDates:sapfromDate, tcstoDates: saptoDate, partyCodes:""
              })})
            
            const salesdata = await res.json();
            const fsalesdata = await salesdata.filter((fdata) => (fdata.HQ_CODE === hqfvalue))
            // const fsalesdata = await salesdata.filter(function (fdata){
            //   return fdata.HQ_Code === values.hqCode;
            // })
            // console.log(salesdata);
            // console.log(fsalesdata);
            SetTcsdbdata(salesdata);
            setFiltereddata(fsalesdata);
            setIsLoading(false);
            setBtnstate('');
            setBtnreport('none');
            setBtnfinalreport('');
            // console.log(tcsdbdata);
        } 
        } catch (err) {
            console.log(err);
            setIsLoading(false);
            
        }
    }
   
    const handlehqwisereport = async () => {
      setBtnfinalreport('true');
      // const finalfsalesdata = await tcsdbdata.filter((fdata) => (fdata.HQ_Code === hqfvalue))
      // const finalfsalesdata = await tcsdbdata.filter((fdata) => (fdata.HQ_Code === filtervalues))
      const finalfsalesdata = tcsdbdata.filter((fdata) => filtervalues.includes(fdata.HQ_CODE))
      // console.log(finalfsalesdata);

      setFiltereddata(finalfsalesdata);      
      setBtnfinalreport('');

    }


    const divwisedncnreport = async () => {        
        try {
            // allhqasmdata();
            let frontsitedata = finalsitemapdata;
            let frontitemDivision = finaldivmapdata;            
            if(!senempmapdata || !frontsitedata || !frontitemDivision || !tcsfromDate || !tcstoDate || !hqfvalue || hqfvalue === "--Select--")
            {
                toast.error("Please select above field .", { position: "top-center" });
            }
            else if(tcsfromDate > tcstoDate)
            {
              toast.error("Please select the Correct Date Range.", { position: "top-center" });
            }
            else if((Date.parse(datetoValue)-Date.parse(datefromValue))/86400000 > 32)
            {
              toast.error("Please select the below 3 Months data.", { position: "top-center" });
            }
            else
            {
            setBtndncnreport('true');
            setBtnstate('none');
            setIsLoading(true);            
            const data = { frontsitedatas:"", frontitemDivisions:"", tcsfromDates:"", tcstoDates:"", partyCodes:"" };

            const res = await fetch('/tcsdb/sapdivwisedncnreports',{
              method: "POST",
              headers:{
                  // "Accept": "application/json",
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({
                frontsitedatas:finalplantmapdata, frontitemDivisions: finaldivmapdata, tcsfromDates:sapfromDate, tcstoDates: saptoDate, partyCodes:""
              })})
            
            const salesdata = await res.json();
            const fsalesdata = await salesdata.filter((fdata) => (fdata.HQ_CODE === hqfvalue))
            // const fsalesdata = await salesdata.filter(function (fdata){
            //   return fdata.HQ_Code === values.hqCode;
            // })
            // console.log(salesdata);
            // console.log(fsalesdata);
            SetTcsdbdncndata(salesdata);
            setFiltereddncndata(fsalesdata);
            setIsLoading(false);
            setBtnstate('');
            setBtndncnreport('none');
            setBtnfinaldncnreport('');
            // console.log(tcsdbdata);
        } 
        } catch (err) {
            console.log(err);
            setIsLoading(false);
            
        }
    }
   
    const handlehqwisedncnreport = async () => {
      setBtnfinaldncnreport('true');
      // const finalfsalesdata = await tcsdbdata.filter((fdata) => (fdata.HQ_Code === hqfvalue))
      // const finalfsalesdata = await tcsdbdata.filter((fdata) => (fdata.HQ_Code === filtervalues))
      const finalfsalesdata = tcsdbdncndata.filter((fdata) => filtervalues.includes(fdata.HQ_CODE))
      // console.log(finalfsalesdata);

      setFiltereddncndata(finalfsalesdata);      
      setBtnfinaldncnreport('');

    }


    const pagauth = async() => {
        const pageids = "TcsaboveasmsalesPage";
        const res = await fetch('/user/pageaccessdatas/'+ pageids, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          credentials: "include"
        })      
        // const expdata = await res.json();  
        if(res.status === 404)
        {
          navigate('/Home');
          toast.error("You don't have access this page.", { position: "top-center" });
        }
      }

      const handlehqlistdata = async(e) => {
        setHqfvalue(e.target.value);
        const hqfvaluedata = e.target.value;
        if(hqfvaluedata === "--Select--")
          {
              toast.error("Please Select the HQ Data.", { position: "top-center" });
          } 
          else{
        const hqnamefvalue = values.filter((fdata) => (fdata.hqCode === hqfvaluedata))
        setSelectinvsitedata(hqfvaluedata);
        setHqNamedata(hqnamefvalue[0].hqName);
        // console.log(hqnamefvalue[0].hqName);
          }
      }


      const customStyles = {
        headRow: {
          style:{
            backgroundColor:'purple',
            color:'white',            
            height:80,                  
          },    
        },
        headCells:{
          style:{
            fontSize:'14px',
            
          }
        }
      }
      
        const columns = [
          {
              name: "Sales_Invoice_No/Sales_Return_No",
              selector: "COMMERCIAL_INV_NO",
                            
            },
          {
            name: "Sales_Return_Type",
            selector: "BILLING_DISCRIPTION",
            // sortable:true,
            
          },
          {
            name: "Sales_Invoice_Date/Sales_Return_Date",
            selector: "BILLING_DATE",
          },
          {
            name: "Party_Code",
            selector: "SOLD_TO_PARTY",      
          },
          {
            name: "Party_Name",
            selector: "CUST_NO_SP",
            width: "240px",
            wrap:true,
          },
          {
            name: "Party_Wise_City",
            selector: "SHIPTOCITY_CUSTOMER",
            sortable:true,
          },
          {
            name: "Party_Wise_State",
            selector: "STATE",
          },
          {
            name: "Item_Code",
            selector: "MATERIAL_CODE",
          },
          {
            name: "Alternate_S/W_Code",
            selector: "MATERIAL_CODE",
          },
          {
            name: "Item_Name",
            selector: "MATERIAL_DISCRIPTION",
            width: "240px",
            wrap:true,
          },
          {
            name: "HQ_Code",
            selector: "HQ_CODE",
          },
          {
            name: "HQ_Name",
            selector: "HQ_NAME",
          },
          {
            name: "Item_Division",
            selector: "DIVISION_DESCPRIPTION",
          },
          {
            name: "Site",
            selector: "PLANT",
          },
          {
            name: "Total_Qty",
            selector: "BILL_QUANTITY",
          },
          {
            name: "CUSTOMER_CATOGERY",
            selector: "CUSTOMER_CATOGERY",
          },          
          {
            name: "Amount_after_Discount",            
            selector: "TAXABLE_AMOUNT", 
            
          },
        ];

       



    useEffect (() => {
        pagauth();        
      }, []);

  return (
    <>
    <div className="">
    <Navbar />   
    </div>
    <div className='d-flex justify-content-center align-items-top bg-white vh-100'>
    <div className='mt-3 w-100'>
    <div className='bg-white p-3 rounded w-100'>
    <div className='bg-info w-25 rounded-1 mt-1'>Division Wise SAP Sales Report SO/ASM :</div>
    <div className='d-flex mt-2 flex-column align-items-center'>
    <div id="collapseExample">
              <div className="card card-body bg-success-subtle">
                <div className="container" style={{ fontSize: "13px" }}>
                  <div className="row align-items-start">
                    <div className="col">
                      <div className="label">HQ Code: </div>
                      <button className='btn btn-sm btn-primary rounded-1' style={{width:"100px"}} onClick={()=>hqcodelist(userData.hqCode)}>Select</button>
                    </div>
                    <div className="col">
                      <div className="label">Select HQ Code: </div>
                      <select className='ms-0 rounded-1' style={{width:"150px"}} onChange={handlehqlistdata} >
                        <option defaultValue={true}>--Select--</option>
                        {
                          values.map((opt,i)=><option key={i}>{opt.hqCode}</option>)
                        }   
                        </select>
                    </div>
                    <div className="col">
                      <div className="label" style={{width:"200px"}}>HQ Name: </div>
                      <span className='ms-0 me-0'>{hqNamedata}</span>
                    </div>
                    <div className="col">
                      <div className="label" style={{width:"100px"}}>Sales Value: </div>
                      <span className='ms-0 me-0'>{hqdatasval}</span>
                    </div>
                    <div className="col">
                      <div className="label" style={{width:"180px"}}></div>
                      <button className='btn btn-sm btn-primary rounded-1' onClick={handlehqwisedata}>Generate HQ/Rs. Wise Pivot</button>
                      
                    </div>
                    <div className="col">
                      <div className="label" style={{width:"150px"}}></div>                      
                      <span style={{display:hqbtnstate}}><ExportToExcelLive reportLiveDetails={values} /></span>
                    </div>
                    </div>
                  </div>
                  </div>
                  </div>    
    <div className='mb-2'> <label style={{textAlign:"right", width:"100px"}}>From Date:-</label>    
    <input type="date" id="fromdate" onChange={(e) => handlefromDateUpdate(e)} />
    <label style={{textAlign:"right", width:"100px"}}>To Date:-</label>    
    <input style={{marginRight:"50px"}} type="date" id="todate" onChange={(e) => handletoDateUpdate(e)} />    
    </div>        
    <button className='btn btn-primary rounded-1' style={{display:btnsitestate}} onClick={empdivemapdata}>1. Select Division Data Details</button>
    <button className='btn btn-primary rounded-1' style={{display:btnrefstate}} onClick={empsitemapdata}>2. Select Site Data Details</button>
            <span><button className='btn btn-primary rounded-1' style={{display:btnreport}} disabled={btnreport} onClick={divwisereport}>3. Refresh Sales Report</button>            
            <button className='btn btn-primary rounded-1' style={{display:btnfinalreport}} disabled={btnfinalreport} onClick={handlehqwisereport}>4. All HQ Wise Sales Report</button>
            <button className='btn btn-primary rounded-1 ms-1' style={{display:btndncnreport}} disabled={btndncnreport} onClick={divwisedncnreport}>8. Referesh Debit/Credit Note</button>            
            <button className='btn btn-primary rounded-1 ms-1' style={{display:btnfinaldncnreport}} disabled={btnfinaldncnreport} onClick={handlehqwisedncnreport}>9. All HQ Wise Debit/Credit Report</button></span>
            <div><span style={{fontSize:"12px"}}>Division:- {finaldivmapdata}</span></div>                           
            {/* <button className='btn btn-primary rounded-1' onClick={divwisesalesreport}> Details</button> */}
   <div className='bg-info w-50 rounded-1 mt-1'>SAP Live Invoice Details  :</div>
   {(isLoading) ? <Loaders /> : 
  <DataTableExtensions
  columns={columns}
  data={filtereddata}
  exportHeaders={true}
  print={false}
  fileName={"Division_Wise_Sales_Report"}
  >
  
    <DataTable
    // title="HQ Wise For Month Sales Details:"
    // columns={columns}
    // data={filtereddata}
    customStyles={customStyles}
    pagination
    fixedHeader
    fixedHeaderScrollHeight="450px"   
    
    
    
    
    
    // selectableRows
    // selectableRowsHighlight
    
    // actions={<CSVLink data={filtereddata} filename='TMPerformanceReports' onClick={() => {}} className="btn btn-sm btn-info">Performance Data Export in Excel</CSVLink>}    
    // subHeader
    // subHeaderComponent={
    //   <input type='text' placeholder='Search here' className='w-25 form-control'
    //   value={search} onChange={(e) => setSearch(e.target.value.replace(/[^a-z^ -]/gi, ''))}
    //    />
    // }
    // subHeaderAlign='center' 
    
    
     /> 
     </DataTableExtensions>
     }
<div className='bg-info w-50 rounded-1 mt-1'>SAP Live Debit Credit Note Details  :</div>
     <DataTableExtensions
  columns={columns}
  data={filtereddncndata}
  exportHeaders={true}
  print={false}
  fileName={"Division_Wise_Sales_Report"}
  >
  
    <DataTable    
    customStyles={customStyles}
    pagination
    fixedHeader
    fixedHeaderScrollHeight="450px"      
     /> 
     </DataTableExtensions>
    </div>    
            </div>
        </div>
    </div>
    </>
  )
}

export default Sapsoreport